import { getCorrectedURLSearchParams } from '@novakid/frontend-core';
import { REGIONAL_DOMAINS_PARAMS, RegionalDomain } from 'consts';
import { UserService } from 'services';

export function getRegionalDomainRedirectUrl(search: string, host: RegionalDomain) {
  const searchParams = getCorrectedURLSearchParams(search);

  Object.entries(REGIONAL_DOMAINS_PARAMS[host]).forEach(([key, value]) => {
    searchParams.set(key, value);
  });

  if (UserService.hasUserCredentials) {
    searchParams.set('token', UserService.authToken as string);
    searchParams.set('userId', `${UserService.userId}`);
  }

  const { pathname } = window.location;

  const path = pathname === '/' ? '' : pathname;

  return `https://school.novakidschool.com${path}?${searchParams.toString()}`;
}